import React, { useState } from 'react';
import './ModalHeader.scss';
const ModalHeader: React.FC = () => {
  const mockDates = [
    { date: '01 Aug 2024', label: 'Prev. Treatment Date' },
    { date: '05 Sep 2024', label: 'Current Date' },
    { date: '10 Oct 2024', label: 'Next Treatment Date' },
  ];

  const [currentIndex, setCurrentIndex] = useState(1);

  const handlePrev = () => {
    if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
  };

  const handleNext = () => {
    if (currentIndex < mockDates.length - 1) setCurrentIndex(currentIndex + 1);
  };

  return (
    <div className="custom-modal-header">
      
      {/* Prev. Treatment Date */}
      <div className={`prev-treatment ${currentIndex === 0 ? 'disabled' : ''}`} onClick={handlePrev}>
        <span className="icon">{'<'}</span>
        <span className="label">Prev. Treatment Date</span>
      </div>

      {/* Current Date */}
      <div className="modal-title">{mockDates[currentIndex].date}</div>

      {/* Next Treatment Date */}
      <div className={`next-treatment ${currentIndex === mockDates.length - 1 ? 'disabled' : ''}`} onClick={handleNext}>
        <span className="label">Next Treatment Date</span>
        <span className="icon">{'>'}</span>
      </div>
    </div>
  );
};

export default ModalHeader;
